/**
 * Entry point. Wires the app state, the account UI and the sync engine
 * together, which keeps app.ts and account.ts from importing each other.
 */
import './styles.css';
import * as Account from './account';
import * as Sync from './sync';
import { initApp, refreshAllViews, store } from './app';

function boot(): void {
  Sync.bindStore({
    ...store,
    onRemoteChange: refreshAllViews,
    onAuthChange: () => {
      Account.render();
    },
  });

  initApp();
  Account.init({ onDataReset: refreshAllViews });
  Sync.init();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
